import { render, staticRenderFns } from "./ListPricing.vue?vue&type=template&id=3c706436&scoped=true&"
import script from "./ListPricing.vue?vue&type=script&lang=ts&"
export * from "./ListPricing.vue?vue&type=script&lang=ts&"
import style0 from "./ListPricing.vue?vue&type=style&index=0&id=3c706436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c706436",
  null
  
)

export default component.exports